import React from "react";

import { Button } from "shipnow-mercurio";
import PropTypes from "prop-types";

const DEFAULT_PROPS = {
  disabled: false,
  onEdit: () => {},
  id: "",
  margin: "a-0",
};

export const EditButton = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  return (
    <Button
      disabled={attrs.disabled}
      icon="edit"
      iconsize="minor"
      id={attrs.id}
      margin={attrs.margin}
      onClick={attrs.onEdit}
      type="text"
    >
      Editar
    </Button>
  );
};

EditButton.propTypes = {
  disabled: PropTypes.bool,
  onEdit: PropTypes.func,
  id: PropTypes.string,
  margin: PropTypes.string,
};
